export default __webpack_public_path__ + "static/media/about-part-1-2.6482bf44.jpg";